export default __webpack_public_path__ + "img/809f92e88bf9dbd4d43825e21c2acb75.png";